export default __webpack_public_path__ + "static/media/jasmine_and_ian-0466.e037f93e.jpg";